/*
 *
 *  #region Copyright (c), Crompton Greaves Consumer Electricals Ltd.
 *  Crompton R&D IoT Department Proprietary Software
 *
 *  This file is part of Crompton Smart Home SDK
 *  Copyright (c) 2024 Crompton Greaves Consumer Electricals Ltd. All rights reserved.
 *  Contact: CROMPTON DEVELOPER SUPPORT <iot.platform@crompton.co.in>
 *
 *  This software, including documentation, is protected by copyright by
 *  Crompton Greaves Consumer Electricals Ltd. All rights are reserved. Copying, including reproducing, storing,
 *  adapting or translating, any or all of this material requires the prior written consent of
 *  Crompton Greaves Consumer Electricals Ltd. This material also contains confidential information which should not
 *  be disclosed to others without the prior written consent of Crompton Greaves Consumer Electricals Ltd.
 *
 *  Filename :
 *  * Created on: <Date>
 *  Author    :
 *  * #endregion
 * /
 *
 */
function Card(props) {
  const { variant, extra, children, ...rest } = props;
  return (
    <div
      className={`!z-5 relative flex flex-col rounded-[20px] bg-white bg-clip-border shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:text-white dark:shadow-none ${extra}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
